<div class="roles-table">
  <div class="roles-column" *ngFor="let grp of rolesGrouped">
    <div class="roles-cell" *ngFor="let r of grp">
      <input
        class="role-checkbox"
        type="checkbox"
        [id]="'check-role-' + r.name"
        [checked]="isSelected(r.name)"
        (change)="setSelected(r.name, $event.target.checked)"
      />
      <label class="role-name" [for]="'check-role-' + r.name">{{ r.name }}</label>
      <label class="role-description" [for]="'check-role-' + r.name">{{ r.description }}</label>
    </div>
  </div>
</div>
